import { Page } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers, withPageProviders } from '../../../context/page-context';
import { FeaturesCard } from '../components/features-card';
import { OtherConfigurationsCard } from '../components/other-configurations-card';
import { ShopifyConfigurationsAlert } from '../components/shopify-configurations-alert';
import { StoreSettingsCard } from '../components/store-settings-card';
import { HELP_PATH, I18N_PAGE, PRODUCT_TOUR_ID } from '../constants';
import { useVueBridgeRefresh } from '../hooks/use-vue-bridge-refresh';
import type { ConfigurationsGeneralPageProps } from '../types';

export const ConfigurationsGeneralPage = withPageProviders<ConfigurationsGeneralPageProps>(
  ConfigurationsGeneralPageContent,
);

function ConfigurationsGeneralPageContent({
  openVueModal,
  vueRevision,
}: ConfigurationsGeneralPageProps) {
  const { navigationHandler } = useHandlers();

  useVueBridgeRefresh(vueRevision);

  return (
    <Page
      title={t(`${I18N_PAGE}.title`)}
      primaryAction={{
        label: t(`${I18N_PAGE}.actions.setup_assistance`),
        icon: 'checkCircle',
        // `/help` is top-level: no site ID or environment.
        onClick: () =>
          navigationHandler.navigate(HELP_PATH, { excludeSiteId: true, excludeSiteEnv: true }),
      }}
      secondaryActions={[
        {
          label: t(`${I18N_PAGE}.actions.watch_tour`),
          icon: 'playCircle',
          // Only a full page load hands the tour ID to Intercom.
          onClick: () =>
            navigationHandler.navigate('/', {
              absolute: true,
              query: { product_tour_id: PRODUCT_TOUR_ID },
            }),
        },
      ]}
    >
      <ShopifyConfigurationsAlert />
      <FeaturesCard openVueModal={openVueModal} />
      <StoreSettingsCard openVueModal={openVueModal} />
      <OtherConfigurationsCard openVueModal={openVueModal} />
    </Page>
  );
}
